/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientCompany } from './';
import {
    ClientCompanyFromJSON,
    ClientCompanyFromJSONTyped,
    ClientCompanyToJSON,
} from './';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';
import type { FreelancerComplianceResource } from './';
import {
    FreelancerComplianceResourceFromJSON,
    FreelancerComplianceResourceFromJSONTyped,
    FreelancerComplianceResourceToJSON,
} from './';
import type { FreelancerFeeTypeResource } from './';
import {
    FreelancerFeeTypeResourceFromJSON,
    FreelancerFeeTypeResourceFromJSONTyped,
    FreelancerFeeTypeResourceToJSON,
} from './';
import type { InvoicingModeType } from './';
import {
    InvoicingModeTypeFromJSON,
    InvoicingModeTypeFromJSONTyped,
    InvoicingModeTypeToJSON,
} from './';
import type { Tax } from './';
import {
    TaxFromJSON,
    TaxFromJSONTyped,
    TaxToJSON,
} from './';
import type { TaxStatus } from './';
import {
    TaxStatusFromJSON,
    TaxStatusFromJSONTyped,
    TaxStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface ContractContextResource
 */
export interface ContractContextResource {
    /**
     * 
     * @type {ClientCompany}
     * @memberof ContractContextResource
     */
    clientCompany: ClientCompany;
    /**
     * 
     * @type {boolean}
     * @memberof ContractContextResource
     */
    isPrePayment: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContractContextResource
     */
    termsAndConditionsUrl?: string;
    /**
     * 
     * @type {Array<Tax>}
     * @memberof ContractContextResource
     */
    taxes: Array<Tax>;
    /**
     * 
     * @type {TaxStatus}
     * @memberof ContractContextResource
     */
    taxStatus?: TaxStatus;
    /**
     * 
     * @type {string}
     * @memberof ContractContextResource
     */
    maltBillingEntityName?: string;
    /**
     * 
     * @type {InvoicingModeType}
     * @memberof ContractContextResource
     */
    invoicingModeType: InvoicingModeType;
    /**
     * 
     * @type {Currency}
     * @memberof ContractContextResource
     */
    clientCurrency: Currency;
    /**
     * 
     * @type {Currency}
     * @memberof ContractContextResource
     */
    freelancerCurrency: Currency;
    /**
     * 
     * @type {number}
     * @memberof ContractContextResource
     */
    freelancerFeePercent: number;
    /**
     * 
     * @type {number}
     * @memberof ContractContextResource
     */
    freelancerFeeTaxPercent: number;
    /**
     * 
     * @type {FreelancerFeeTypeResource}
     * @memberof ContractContextResource
     */
    freelancerFeeType: FreelancerFeeTypeResource;
    /**
     * 
     * @type {FreelancerComplianceResource}
     * @memberof ContractContextResource
     */
    freelancerCompliance: FreelancerComplianceResource;
    /**
     * 
     * @type {string}
     * @memberof ContractContextResource
     */
    briefId?: string;
}

/**
 * Check if a given object implements the ContractContextResource interface.
 */
export function instanceOfContractContextResource(value: object): value is ContractContextResource {
    if (!('clientCompany' in value) || value['clientCompany'] === undefined) return false;
    if (!('isPrePayment' in value) || value['isPrePayment'] === undefined) return false;
    if (!('taxes' in value) || value['taxes'] === undefined) return false;
    if (!('invoicingModeType' in value) || value['invoicingModeType'] === undefined) return false;
    if (!('clientCurrency' in value) || value['clientCurrency'] === undefined) return false;
    if (!('freelancerCurrency' in value) || value['freelancerCurrency'] === undefined) return false;
    if (!('freelancerFeePercent' in value) || value['freelancerFeePercent'] === undefined) return false;
    if (!('freelancerFeeTaxPercent' in value) || value['freelancerFeeTaxPercent'] === undefined) return false;
    if (!('freelancerFeeType' in value) || value['freelancerFeeType'] === undefined) return false;
    if (!('freelancerCompliance' in value) || value['freelancerCompliance'] === undefined) return false;
    return true;
}

export function ContractContextResourceFromJSON(json: any): ContractContextResource {
    return ContractContextResourceFromJSONTyped(json, false);
}

export function ContractContextResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractContextResource {
    if (json == null) {
        return json;
    }
    return {
        
        'clientCompany': ClientCompanyFromJSON(json['clientCompany']),
        'isPrePayment': json['isPrePayment'],
        'termsAndConditionsUrl': json['termsAndConditionsUrl'] == null ? undefined : json['termsAndConditionsUrl'],
        'taxes': ((json['taxes'] as Array<any>).map(TaxFromJSON)),
        'taxStatus': json['taxStatus'] == null ? undefined : TaxStatusFromJSON(json['taxStatus']),
        'maltBillingEntityName': json['maltBillingEntityName'] == null ? undefined : json['maltBillingEntityName'],
        'invoicingModeType': InvoicingModeTypeFromJSON(json['invoicingModeType']),
        'clientCurrency': CurrencyFromJSON(json['clientCurrency']),
        'freelancerCurrency': CurrencyFromJSON(json['freelancerCurrency']),
        'freelancerFeePercent': json['freelancerFeePercent'],
        'freelancerFeeTaxPercent': json['freelancerFeeTaxPercent'],
        'freelancerFeeType': FreelancerFeeTypeResourceFromJSON(json['freelancerFeeType']),
        'freelancerCompliance': FreelancerComplianceResourceFromJSON(json['freelancerCompliance']),
        'briefId': json['briefId'] == null ? undefined : json['briefId'],
    };
}

export function ContractContextResourceToJSON(value?: ContractContextResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clientCompany': ClientCompanyToJSON(value['clientCompany']),
        'isPrePayment': value['isPrePayment'],
        'termsAndConditionsUrl': value['termsAndConditionsUrl'],
        'taxes': ((value['taxes'] as Array<any>).map((v) => TaxToJSON(v))),
        'taxStatus': TaxStatusToJSON(value['taxStatus']),
        'maltBillingEntityName': value['maltBillingEntityName'],
        'invoicingModeType': InvoicingModeTypeToJSON(value['invoicingModeType']),
        'clientCurrency': CurrencyToJSON(value['clientCurrency']),
        'freelancerCurrency': CurrencyToJSON(value['freelancerCurrency']),
        'freelancerFeePercent': value['freelancerFeePercent'],
        'freelancerFeeTaxPercent': value['freelancerFeeTaxPercent'],
        'freelancerFeeType': FreelancerFeeTypeResourceToJSON(value['freelancerFeeType']),
        'freelancerCompliance': FreelancerComplianceResourceToJSON(value['freelancerCompliance']),
        'briefId': value['briefId'],
    };
}

